// extracted by mini-css-extract-plugin
module.exports = {"voopoBtn":"Button_voopoBtn__1s9Qh","voopoBtnLight":"Button_voopoBtnLight__2ePqR","voopoBtnWhite":"Button_voopoBtnWhite__1drXX"};